import { ButtonPrimary } from 'components/Button'
import styled, { css } from 'styled-components'

export const MainContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.cardPrimary};
  /* padding: 16px; */
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.09);

  width: 100%;
  position: relative;
`

export const TableWrapper = styled.div`
  position: relative;
  overflow-x: auto;
  border-radius: 16px 16px 0 0;
  -webkit-overflow-scrolling: touch;
  touch-action: auto;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  & > table {
    width: 100%;
    min-width: 750px;
  }

  thead {
    position: -webkit-sticky;
    background: ${({ theme }) => theme.cardPrimary};
    height: auto;
    box-sizing: border-box;
    display: table-header-group;
    border-bottom: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  }

  th {
    white-space: nowrap;
    padding: 16px;
    background: ${({ theme }) => theme.cardPrimary};
  }

  td {
    white-space: nowrap;
  }
`

export const Table = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
  min-width: 850px;
  width: 100%;
  table-layout: fixed;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    table-layout: auto;
  `}
`

export const Th = styled.th<{ sortable?: boolean; active?: boolean; width?: string }>`
  box-sizing: border-box;
  margin: 0px;
  width: ${({ width }) => width || 'auto'};
  min-width: ${({ width }) => width || '100px'};
  font-weight: 700;
  font-size: 16px;
  color: ${({ theme, active }) => (active ? theme.textPrimary : theme.textSecondary)};
  line-height: 24px;
  padding: 12px 16px;
  vertical-align: middle;
  position: relative;
  // background-color: ${({ theme, active }) => (active ? `${theme.cardBorderSecondary} !important` : 'transparent')};

  ${({ sortable, theme }) =>
    sortable &&
    css`
      cursor: pointer;

      &:hover {
        color: ${theme.textPrimary};
        // background-color: ${theme.cardSecondary};
      }

      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    `}
`

export const Td = styled.td<{ width?: string }>`
  padding: 12px 16px;
  color: white;
  font-variant-numeric: tabular-nums;
  font-weight: 500;
  width: ${({ width }) => width || 'auto'};
  min-width: ${({ width }) => width || '100px'};
  vertical-align: middle;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const FlexRowCenter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
`

export const HeaderCol = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;

  div {
    /* width: 100%; */
    white-space: wrap;
    text-align: center;
  }

  .title {
    cursor: help;
  }
`

// Subgrid for header
export const HeaderRow = styled.div`
  grid-area: header;
  display: grid;
  grid-template-columns: 260px 230px 20px repeat(2, 1fr) 180px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    grid-template-columns: 1fr repeat(3, 0px) repeat(1, 1fr) 180px;
  `}

  /* height: 60px; */

  padding: 16px;

  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.cardBorderSecondary};
`

// Subgrid for header
export const V2HeaderRowFlex = styled.div`
  grid-area: header;
  display: grid;
  grid-template-columns: 260px 230px repeat(2, 1fr);
  ${({ theme }) => theme.mediaWidth.upToSmall`
  grid-template-columns: 1fr repeat(2, 0px) repeat(1, 1fr)
`}

  /* height: 60px; */

  padding: 16px;

  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.cardBorderSecondary};
`

export const ToggleWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const ToggleLabel = styled.div`
  opacity: 0.6;
  margin-right: 10px;
`
export const ResponsiveButtonPrimary = styled(ButtonPrimary)`
  padding: 6px 16px;
  border: none;
  width: fit-content;

  background-color: transparent;

  border-radius: 4px;
  border: 1px solid #64748b;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex: 1 1 auto;
    // width: 100%;
  `};

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  color: ${({ theme }) => theme.textPrimary};

  &:hover {
    background: ${({ theme }) => theme.stateOverlayHover};
  }
`

export const PositionListFooter = styled.div`
  display: flex;
  padding: 16px;
  justify-content: flex-end;
  gap: 24px;
  /* border-bottom: 1px solid ${({ theme }) => theme.cardBorderPrimary}; */
`
